import { gql } from "@apollo/client";

/**
 * GraphQL queries and mutations for Favorites feature.
 * Allows agents to favorite listings for themselves or their buyers.
 */

// Get all favorites for an agent
export const GET_AGENT_FAVORITES = gql`
  query getAgentFavorites($agentId: String!) {
    getAgentFavorites(agentId: $agentId) {
      _id
      favoriteType
      createdAt
      listing {
        _id
        streetAddr
        city
        state
        zip
        beds
        baths
        price
        sqFt
        propertyType
        propertyCategory
        expiration
        imageURLs
        user {
          firstName
          lastName
          email
          phone
        }
        company {
          companyName
        }
        office {
          name
        }
        amenities {
          _id
          title
        }
      }
      agent {
        firstName
        lastName
        email
      }
      company {
        companyName
      }
    }
  }
`;

// Get all favorites for a buyer
export const GET_BUYER_FAVORITES = gql`
  query getBuyerFavorites($buyerId: String!) {
    getBuyerFavorites(buyerId: $buyerId) {
      _id
      favoriteType
      createdAt
      listing {
        _id
        streetAddr
        city
        state
        zip
        beds
        baths
        price
        sqFt
        propertyType
        propertyCategory
        expiration
        user {
          firstName
          lastName
          email
          phone
        }
        company {
          companyName
        }
        office {
          name
        }
        amenities {
          _id
          title
        }
      }
      buyer {
        firstName
        lastName
        email
      }
      addedByAgent {
        firstName
        lastName
        email
      }
      company {
        companyName
      }
    }
  }
`;

// Check if a listing is favorited by agent or any of their buyers
export const CHECK_LISTING_FAVORITE_STATUS = gql`
  query checkListingFavoriteStatus($listingId: String!, $agentId: String!) {
    checkListingFavoriteStatus(listingId: $listingId, agentId: $agentId) {
      isFavoritedByAgent
      agentFavoriteId
      buyerFavorites {
        buyerId
        buyerName
        favoriteId
      }
    }
  }
`;

// Add listing to agent's favorites
export const ADD_TO_AGENT_FAVORITES = gql`
  mutation addToAgentFavorites($input: FavoriteInput!) {
    addToAgentFavorites(input: $input) {
      _id
      favoriteType
      listing {
        _id
        streetAddr
      }
      agent {
        firstName
        lastName
      }
    }
  }
`;

// Add listing to buyer's favorites
export const ADD_TO_BUYER_FAVORITES = gql`
  mutation addToBuyerFavorites($input: FavoriteInput!) {
    addToBuyerFavorites(input: $input) {
      _id
      favoriteType
      listing {
        _id
        streetAddr
      }
      buyer {
        firstName
        lastName
      }
    }
  }
`;

// Remove a favorite by ID
export const REMOVE_FROM_FAVORITES = gql`
  mutation removeFromFavorites($favoriteId: String!) {
    removeFromFavorites(favoriteId: $favoriteId) {
      _id
    }
  }
`;

// Remove listing from agent's favorites
export const REMOVE_LISTING_FROM_AGENT_FAVORITES = gql`
  mutation removeListingFromAgentFavorites($listingId: String!, $agentId: String!) {
    removeListingFromAgentFavorites(listingId: $listingId, agentId: $agentId) {
      _id
    }
  }
`;

// Remove listing from buyer's favorites
export const REMOVE_LISTING_FROM_BUYER_FAVORITES = gql`
  mutation removeListingFromBuyerFavorites($listingId: String!, $buyerId: String!) {
    removeListingFromBuyerFavorites(listingId: $listingId, buyerId: $buyerId) {
      _id
    }
  }
`;
